const inlineStyles = {
    plot: {
        fontFamily: "'Roboto', arial, sans-serif",
    },
};
export default inlineStyles;
